import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// actions
import { fetchMutualConnections, resetMutualConnections } from 'actions/mutualConnectionsActions';

// components
import ConnectionDialog from 'components/ConnectionDialog/ConnectionDialog';
import Translate from 'components/Translate';

const MutualConnectionsModal = ({
    displayName,
    isModalOpen,
    onCloseModal,
    mutualConnectionsCount,
    forceCloseOnNavigation
}) => {
    const dispatch = useDispatch();

    /** Redux states */
    const { connectionList, isFetching } = useSelector((state) => state.mutualConnections);

    useEffect(() => {
        return () => {
            dispatch(resetMutualConnections());
        };
    }, []);

    useEffect(() => {
        if (isModalOpen) {
            fetchNext(true);
        }
    }, [isModalOpen]);

    const hasMoreToFetch = connectionList.length > 0 && connectionList.length < mutualConnectionsCount;
    const showSpinner = isFetching && connectionList.length === 0;
    const fetchNext = useCallback((reset) => dispatch(fetchMutualConnections({ displayName, reset })), [displayName]);

    return (
        isModalOpen && (
            <ConnectionDialog
                modalOpen={isModalOpen}
                onClose={onCloseModal}
                title={<Translate ns="connections" content="mutual_connections" />}
                connectionList={connectionList}
                isFetching={isFetching}
                showSpinner={showSpinner}
                forceCloseOnNavigation={forceCloseOnNavigation}
                hasMore={hasMoreToFetch}
                fetchNext={() => fetchNext(false)}
                disableMutualConnection={true}
            />
        )
    );
};

MutualConnectionsModal.defaultProps = {
    forceCloseOnNavigation: false
};

MutualConnectionsModal.propTypes = {
    displayName: PropTypes.string.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    mutualConnectionsCount: PropTypes.number.isRequired,
    forceCloseOnNavigation: PropTypes.bool
};

export default MutualConnectionsModal;
